import * as React from "react";
import type { SVGProps } from "react";
const SvgCaretRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#050033"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M.83.455c.439-.44 1.151-.44 1.59 0l6.75 6.75c.44.439.44 1.151 0 1.59l-6.75 6.75a1.125 1.125 0 0 1-1.59-1.59L6.784 8 .83 2.046a1.125 1.125 0 0 1 0-1.591"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCaretRight;
